import { admin_type } from '@/api/types/getAdmin';
import { DeleteButton } from '@/components/buttons/delete';
import { ColumnType } from '@/types';
import { DeleteOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { EditButton } from '@refinedev/antd';
import { Space, Tag } from 'antd';

export const getColumns = (
  translate: (key: string) => string,
  isLoadingDeactivate: boolean,
  handleDeactivate: (is_active: boolean) => void,
  setDeactivateId: (id: string) => void,
  setEditAdminData: (data: { id: string; name: string }) => void,
  setIsEditAdminModalOpen: (open: boolean) => void,
  adminType?: string,
  deactivateId?: string
): ColumnType[] => [
  {
    title: translate('listing-admins.id'),
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: translate('listing-admins.name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: translate('listing-admins.email'),
    dataIndex: ['account', 'email'],
    key: 'email',
  },
  {
    title: translate('listing-admins.role.title'),
    dataIndex: 'admin_type',
    key: 'role',
    render: (role: admin_type) => (
      <Tag color="blue">{translate(`listing-admins.role.${role}`)}</Tag>
    ),
  },
  {
    title: translate('listing-admins.status'),
    dataIndex: ['account', 'is_active'],
    key: 'status',
    render: (isActive: boolean) => (
      <Tag color={isActive ? 'green' : 'red'}>
        {isActive ? translate('status.active') : translate('status.inactive')}
      </Tag>
    ),
  },
  ...(adminType === 'SUPER_ADMIN'
    ? [
        {
          title: translate('listing-admins.actions'),
          dataIndex: 'actions',
          key: 'actions',
          //@ts-ignore
          render: (_, record) => (
            <Space>
              <EditButton
                hideText
                size="small"
                onClick={() => {
                  setEditAdminData({ id: record.id, name: record.name });
                  setIsEditAdminModalOpen(true);
                }}
              />
              <DeleteButton
                icon={
                  record.account.is_active ? (
                    <DeleteOutlined className="text-red-500" />
                  ) : (
                    <PlayCircleOutlined className="text-green-500" />
                  )
                }
                className={
                  record.account.is_active
                    ? 'border-red-500'
                    : 'border-green-500'
                }
                hideText
                size="small"
                isLoading={isLoadingDeactivate && deactivateId === record.id}
                onClick={() => {
                  setDeactivateId(record.id);
                }}
                onConfirm={() => {
                  handleDeactivate(record.account.is_active);
                }}
              />
            </Space>
          ),
        },
      ]
    : []),
];
